export enum EGameContext {
    all = 0,
    storyline = 1,
    worldMap = 2,
    mpOnly = 3,
    mpExcluded = 4,
    private = 5,
    event = 6
}